//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoRadioBasic from './demos/DemoRadioBasic.vue'
import DemoRadioColor from './demos/DemoRadioColor.vue'
import DemoRadioDirection from './demos/DemoRadioDirection.vue'
import DemoRadioDense from './demos/DemoRadioDense.vue'
import DemoRadioMandatory from './demos/DemoRadioMandatory.vue'
import DemoRadioLabelSlot from './demos/DemoRadioLabelSlot.vue'
import DemoRadioIcon from './demos/DemoRadioIcon.vue'
import DemoRadioValidation from './demos/DemoRadioValidation.vue'

// code
import {
  radioBasic,
  radioColor,
  radioDirection,
  radioDense,
  radioMandatory,
  radioLabelSlot,
  radioIcon,
  radioValidation,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoRadioBasic,
    DemoRadioColor,
    DemoRadioDirection,
    DemoRadioDense,
    DemoRadioMandatory,
    DemoRadioLabelSlot,
    DemoRadioIcon,
    DemoRadioValidation,
  },
  setup() {
    return {
      codeSnippets: {
        radioBasic,
        radioColor,
        radioDirection,
        radioDense,
        radioMandatory,
        radioLabelSlot,
        radioIcon,
        radioValidation,
      },
    }
  },
}
